import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly supportedLanguages = ['zh_CN', 'zh_TW', 'en_US', 'vi', 'km', 'th', 'lo'];
  private currentLanguage = '';

  setLanguage(language: string) {
    if (!language || this.supportedLanguages.indexOf(language) === -1) {
      return;
    }

    const languageClass = `lang-${language}`;
    if (
      this.currentLanguage === language &&
      document.body.classList.contains(languageClass) &&
      document.documentElement.classList.contains(languageClass)
    ) {
      return;
    }

    this.updateLanguageClass(language);
  }

  private updateLanguageClass(language: string) {
    const languageClass = `lang-${language}`;
    const previousLanguageClass = this.currentLanguage ? `lang-${this.currentLanguage}` : '';
    const targets = [document.documentElement, document.body];

    targets.forEach(target => {
      this.supportedLanguages.forEach(supportedLanguage => {
        target.classList.remove(`lang-${supportedLanguage}`);
      });

      if (previousLanguageClass) {
        target.classList.remove(previousLanguageClass);
      }

      target.classList.add(languageClass);
    });

    this.currentLanguage = language;
  }
}
